import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { IInjectedStylingProps, withStyling } from './higher-order';
import styles from './checkbox.module.scss';

type Attributes = Omit<HTMLAttributes<HTMLDivElement>, 'css'>;

export interface ICheckboxProps extends IInjectedStylingProps, Attributes {
	children?: string;
	disabled?: boolean;
	fullWidth?: boolean;
	name: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
	onLabelClick?: (e: React.MouseEvent<HTMLLabelElement>) => void;
	checked?: boolean;
	centerAlignLabel?: boolean;
	css?: any;
}

const component = ({
	name,
	checked,
	disabled,
	onChange,
	onClick,
	onLabelClick,
	styling,
	centerAlignLabel,
	fullWidth,
	children,
	...rest
}: ICheckboxProps): React.JSX.Element => {
	const fullWidthStyle = fullWidth ? { width: '100%' } : { width: 'auto' };
	const checkboxClassNames = clsx(styling?.getStyle(styles, 'checkbox'));

	return (
		<div
			className={clsx(checkboxClassNames, centerAlignLabel && styling?.getStyle(styles, 'centerAlignLabel'))}
			style={fullWidthStyle}
			{...rest}
		>
			<input
				aria-checked={checked}
				checked={checked}
				className={styling?.getStyle(styles, 'input')}
				disabled={disabled}
				id={name}
				name={name}
				onChange={onChange}
				type="checkbox"
				onClick={onClick}
			/>
			{children && (
				<label
					className={styling?.getStyle(styles, 'label')}
					htmlFor={name}
					style={fullWidthStyle}
					onClick={onLabelClick}
				>
					{children}
				</label>
			)}
		</div>
	);
};

const Checkbox = withStyling(component);
export { Checkbox };
